import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import styles from './TasksController.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useFetchList } from 'store'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

const TasksFilters = (props) => {
	const { taskTypesFilters } = props
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)
	const [id, setId] = useState('')

	useEffect(() => {
		setId(queryParams.q || '')
	}, [queryParams.q])

	const {
		contents: [users],
	} = useFetchList(
		['/users'],
		[
			(json) => {
				return {
					value: json.username ?? '',
					text: json.fullName ?? '',
				}
			},
		],
		60000 * 60 // One hour
	)

	const selectedType = queryParams?.type
		? taskTypesFilters?.find(
				({ value }) =>
					queryParams.type.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const userFilters = Array.isArray(users)
		? [
				{
					value: '',
					text: i18n`Any`,
				},
				...users,
		  ]
		: []

	const mappedTasksFilters = Array.isArray(taskTypesFilters)
		? [
				{
					value: '',
					text: i18n`Any`,
				},
				...taskTypesFilters,
		  ]
		: []

	const selectedUser = queryParams.userId
		? userFilters.find(
				({ value }) =>
					queryParams.userId.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: null

	const handleSubmit = (e) => {
		e.preventDefault()
		setQueryParams({
			page: undefined,
			segment: undefined,
			q: id,
		})
	}

	return (
		<HStack
			className={styles['header-options']}
			align='center'
			justify='space-between'
			gap='xsmall'
			flex={[
				[1, 1],
				[1, 1],
			]}
		>
			<HStack
				align='center'
				justify='flex-start'
				wrap='nowrap'
				gap='xsmall'
			>
				<VStack>
					<small>
						<strong>{i18n`Tasks`}</strong>
					</small>
					<small className='ellipsis'>{i18n`Search by`}:</small>
				</VStack>
				<form onSubmit={handleSubmit}>
					<HStack gap='xsmall' wrap='nowrap'>
						<TextInput
							className={styles['text-input']}
							type='text'
							value={id}
							name='processRequisitionId'
							placeholder={i18n`Process or Requisition`}
							onChange={(e) => {
								setId(e.target.value)
							}}
						/>
						<ActionButton type='submit' secondary>
							<small>
								<strong>{i18n`Search`}</strong>
							</small>
						</ActionButton>
					</HStack>
				</form>
			</HStack>
			<HStack
				align='center'
				justify='flex-end'
				wrap='nowrap'
				gap='xsmall'
				columns={['auto', 'auto', 'auto']}
				flex={[
					[1, 1],
					[1, 1],
					[1, 1],
				]}
			>
				{userFilters.length ? (
					<Dropdown
						className={styles['options-entry']}
						name='userId'
						placeholder={i18n`User`}
						searchable
						value={
							selectedUser !== null
								? selectedUser?.value
								: userFilters?.[0]?.value
						}
						options={userFilters || []}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								userId: e.target.value,
								type: undefined,
							})
						}}
					/>
				) : null}
				<Dropdown
					className={styles['options-entry']}
					name='type'
					placeholder={i18n`Type`}
					searchable
					value={
						selectedType !== null
							? selectedType?.value
							: mappedTasksFilters?.[0]?.value
					}
					options={mappedTasksFilters || []}
					onChange={(e) => {
						setQueryParams({
							page: undefined,
							segment: undefined,
							type: e.target.value,
						})
					}}
				/>
			</HStack>
		</HStack>
	)
}

export default TasksFilters
